module.exports = __webpack_public_path__ + "img/Nautica-F.2804b314.jpg";